
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/facts/suprema",
      function () {
        return require("private-next-pages/facts/suprema/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/facts/suprema"])
      });
    }
  